import React, { useState } from "react";
import { BsArrowDownShort, BsArrowUpRight } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { blogs } from "../../../data/BlogData";
import blogImage from "../../../images/blog.png";
import Footer from "../../shared/Footer";
import Newsletter from "../../shared/Newsletter";
import Pagination from "./Pagination";
const Blog = () => {
  const [page, setPage] = useState(10);
  const [pageCount, setPageCount] = useState(20);
  return (
    <>
      <div className="">
        <div className="text-center flex justify-center flex-col space-y-3 bg-[#F9FAFB] py-10">
          <p className="text-primary font-semibold">Blogs</p>
          <h3 className="text-3xl font-bold text-black">Knoct blog</h3>
          <p className="text-sm text-accent">
            Your happiness speaks of our success!
          </p>
          <div>
            <div className="flex justify-center items-start gap-2 flex-wrap">
              <div className="flex justify-start items-start flex-col ">
                <input
                  type="text"
                  name=""
                  id=""
                  className="px-2 py-1 border border-r-gray-200 rounded-lg text-black focus:outline-primary w-[300px] h-[48px]"
                  placeholder="Enter your email"
                />
                <p className="text-accent text-xs">
                  We care about your data in our{" "}
                  <span className="link">privacy policy</span>
                </p>
              </div>
              <button className="btn  btn-primary text-white h-[48px]">
                Subscribe
              </button>
            </div>
          </div>
        </div>
        <div className="py-10 lg:mx-20 md:mx-10 mx-3 space-y-8 relative">
          <div className="flex justify-between items-center gap-2 flex-wrap">
            <div className="relative">
              <input
                type="text"
                className="w-[310px] h-10 rounded-lg border border-gray-200 focus:outline-primary pl-8 "
                placeholder="Search"
              />
              <FiSearch className="absolute top-[14px] left-2 text-accent" />
            </div>
            <div className="flex  items-center w-[250px] h-10 border border-gray-200 shadow rounded-lg px-1">
              <BsArrowDownShort className="text-2xl text-accent" />

              <select name="" id="" className="w-[98%] focus:outline-none">
                <option
                  value="Newest first"
                  className="py-2 rounded-lg w-[275px]"
                >
                  Newest first
                </option>
                <option
                  value="Newest first"
                  className="py-2 rounded-lg w-[275px]"
                >
                  Newest first
                </option>
              </select>
            </div>
          </div>
          <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-6">
            {blogs.map((item, index) => (
              <div
                key={index}
                className="card card-compact border border-gray-200"
              >
                <figure>
                  <img
                    src={item?.img}
                    alt="Shoes"
                    className="w-full h-[280px]"
                  />
                </figure>
                <div className="card-body">
                  <h2 className="card-title">{item?.title}</h2>
                  <h2 className="card-title text-sm text-accent">
                    {item?.date}
                  </h2>
                  <p className="text-accent text-sm">{item?.text}</p>
                  <div className="card-actions justify-start">
                    <a
                      href="#"
                      className="btn-link font-semibold flex items-center gap-2"
                    >
                      Read Post <BsArrowUpRight className="text-lg" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="border-t border-t-gray-200 py-5">
            <Pagination setPage={setPage} pageCount={pageCount} />
          </div>
        </div>
        <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-5 lg:px-20 md:px-10 px-5 py-20">
          <div className="space-y-5 flex justify-center flex-col">
            <h2 className="lg:text-5xl md:text-4xl sm:text-3xl text-2xl font-bold text-black">
              Its so so easy to get started with knoct
            </h2>
            <p className="text-accent">Start your 30-day free trial today</p>
            <div>
              <button className="btn  btn-outline btn-accent w-[126px] h-[40px] hover:text-white mr-2">
                Learn more
              </button>
              <button className="btn w-[126px] h-[40px] btn-primary text-white">
                Contact us
              </button>
            </div>
          </div>
          <div>
            <img src={blogImage} className="" alt="" />
          </div>
        </div>
      </div>
      <Newsletter />
      <Footer />
    </>
  );
};

export default Blog;
